import { services } from "onearm";
import { GameStates } from "onearm";
import { Timer } from "onearm";

import { SubGameState } from "./SubGameState";

export class FreespinSpinning extends SubGameState {
    enter() {
        const spinType = this.data.spinType || "normal";
        const isQuickOrTurbo = spinType === "quick" || spinType === "turbo";
        const autoplayQuickSpin = this.autoplay.isActive() && this.autoplay.isQuickSpin;
        const autoplayTurboSpin = this.autoplay.isActive() && this.autoplay.isTurboSpin;

        this.isInstantSpin = isQuickOrTurbo || autoplayQuickSpin || autoplayTurboSpin;
        this.isTurboSpin = spinType === "turbo" || autoplayTurboSpin;

        this.stopTimer = new Timer(this.isInstantSpin ? 500 : 1000);
        this.stopTimer.start();

        this.sfx = services.audio.playSfx(this.isInstantSpin ? "spinning_speed" : "spinning_default");
        this.startTime = Date.now();
        this.isSkiped = false;
        this.spinResult = null;

        this.executeSpin();
        this.addSignalHandler(this.hud.onPressSpin, this.skipSpin);
        this.addSignalHandler(this.keyboard.onSpacePress, this.skipSpin);

        if (this.isTurboSpin) {
            this.skipSpin();
        }
    }

    async executeSpin() {
        try {
            this.reels.spin(this.isInstantSpin);
            this.hud.showTopGameLogo();
            this.hud.setFreeSpinsCounter(this.gameLogic.getFreeSpinsLeft() - 1);
            this.spinResult = await this.gameLogic.freeSpin();
        } catch (e) {
            this.onServerError(e);
        }
    }

    onServerError(error) {
        if (error === "-1") {
            this.gameState.rejectSpin();
            this.gameState.goTo(GameStates.FREE_SPIN_SPINNING);
            return;
        }

        this.gameState.goTo(GameStates.ERROR, error);
    }

    skipSpin() {
        if (this.stopTimer && !this.stopTimer.isDone()) {
            this.stopTimer.complete();
            this.isSkiped = true;
        }
    }

    update(dt) {
        super.update(dt);

        this.checkSpinEnd();
    }

    checkSpinEnd() {
        const result = this.spinResult;

        if (result && this.stopTimer && this.stopTimer.isDone()) {
            if (this.sfx && this.isSkiped) {
                this.sfx.stop();
            }
            const quickStop = this.isSkiped || this.isInstantSpin;
            this.gameState.goTo(GameStates.FREE_SPIN_WINNING, { result, quickStop });
        }
    }
}
